import { FinTechOpsCategories, SAS_LAST_UPDATED_AT_S3_PREFIX, SAS_S3_PREFIX } from '../../FinTechOpsConstants';
import { returnUsefulRawDataSas } from '../../sas/SasDataProcessing';
import { SasParsedDetails, SasRawData } from '../../sas/SasInterfaces';
import { useS3Dataset, UseS3DatasetResult } from './useS3Dataset';

export const useSasData = (): UseS3DatasetResult<SasParsedDetails> =>
  useS3Dataset<SasRawData[], SasParsedDetails>({
    prefix: SAS_S3_PREFIX,
    lastUpdatedPrefix: SAS_LAST_UPDATED_AT_S3_PREFIX,
    category: FinTechOpsCategories.sas,
    parse: returnUsefulRawDataSas
  });
